import angular from 'angular';

angular.module('cloudX').directive('cxExecutionDuration', [
  '$translate',
  function($translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        disabled: '=ngDisabled',
        defaultValue: '@default',
      },
      template:
        '<div style="width: 150px; border-spacing: 0">' +
        '  <div ng-show="state.editing" class="input-group">' +
        '    <input type="number" min="0" ng-model="state.hours" ng-disabled="disabled" ng-blur="onblur()" class="form-control"/>' +
        '    <span class="input-group-addon" style="cursor: default; padding: 0; width: 25px" data-translate="h"></span>' +
        '    <input type="number" min="0" ng-model="state.minutes" ng-disabled="disabled" ng-blur="onblur()" class="form-control"/>' +
        '    <div ng-click="clearValue()" class="input-group-addon" style="padding: 0; width: 25px"><span class="fa fa-times"></span></div>' +
        '  </div>' +
        '  <a ng-show="!state.editing" ng-click="editValue()"><span class="glyphicon glyphicon-pencil editable"></span> (<span data-translate="Default"></span> {{renderTime(defaultValue)}})</a>' +
        '</div>',
      require: 'ngModel',
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.state = {
          editing: false,
          minutes: 0,
        };

        scope.renderTime = function(value) {
          if (value >= 60) {
            return (
              Math.floor(value / 60) +
              $translate.instant('h') +
              (value % 60 !== 0 ? (value % 60) + $translate.instant('m') : '')
            );
          }
          if (value > 0) return value + $translate.instant('m');
          return '0' + $translate.instant('m');
        };

        scope.onblur = function() {
          ngModel.$setViewValue(scope.state.minutes + scope.state.hours * 60);
        };

        ngModel.$render = function() {
          console.log(scope.defaultValue);
          console.log(scope.default);
          let value = ngModel.$viewValue;
          let haveValue = value !== undefined && value !== null;
          scope.state = {
            editing: haveValue,
            minutes: haveValue ? value % 60 : undefined,
            hours: haveValue ? Math.floor(value / 60) : undefined,
          };
        };

        scope.clearValue = function() {
          ngModel.$setViewValue(undefined);
          ngModel.$render();
        };

        scope.editValue = function() {
          ngModel.$setViewValue(scope.defaultValue || 0);
          ngModel.$render();
        };
      },
    };
  },
]);
